<!-- Success Modal -->
<div #successModal class="modal fade successModal" id="successModal" tabindex="-1" aria-labelledby="successModalLabel">
    <div class="modal-dialog modal-dialog-bottom">
        <div class="modal-content">
            <div class="modal-body pt-4">
                <div class="text-end">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="inner-content">
                    <img [src]="gifSrc" alt="success image" class="mb-3">
                    <p>
                        Your interest in this <br> {{ forValue }} has been <br> shared successfully.
                    </p>
                    <p class="mb-0">
                        You can expect a call <br> from them.
                    </p>
                    <div class="btn-outer mt-4">
                        <button type="button" class="btn continue-btn" data-bs-dismiss="modal" [style.background-color]="buttonColor">Okay</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>